import React, { useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { DeviceWidth, mobileQuery, useDeviceWidthQuery } from "./MediaQuery";

const navigationSize = 36;
const navigationPadding = 20;

export const MySlider: React.FC<{
  children: React.ReactNodeArray;
  spaceBetween?: number;
  slidesPerView?: "auto" | number;
  autoplayDelay?: number;
  loop?: boolean;
  className?: string;
}> = (props) => {
  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  return (
    <Layout>
      <NavigationPrev ref={prevRef} />

      <Slider
        spaceBetween={props.spaceBetween}
        slidesPerView={props.slidesPerView}
        autoplay={
          props.autoplayDelay
            ? {
                delay: props.autoplayDelay,
                disableOnInteraction: true,
              }
            : undefined
        }
        onInit={(swiper) => {
          // https://github.com/nolimits4web/swiper/issues/3855
          setTimeout(() => {
            const swiperParamsNavigation = swiper.params?.navigation;
            if (swiperParamsNavigation !== undefined) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              // eslint-disable-next-line no-param-reassign
              swiperParamsNavigation.prevEl = nextRef.current;
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              // eslint-disable-next-line no-param-reassign
              swiperParamsNavigation.nextEl = prevRef.current;
            }
            // Re-init navigation
            swiper.navigation?.destroy();
            swiper.navigation?.init();
            swiper.navigation?.update();
          });
        }}
        loop={props.loop}
        mousewheel={{
          forceToAxis: true,
        }}
        className={props.className}
      >
        {props.children.map((child, i) => {
          return <SwiperSlide key={`slider-${i}`}>{child}</SwiperSlide>;
        })}
      </Slider>

      <NavigationNext ref={nextRef} />
    </Layout>
  );
};

const Layout = styled.div`
  position: relative;
`;

const NavigationArrow = styled.div`
  width: ${navigationSize}px;
  height: ${navigationSize}px;
  position: absolute;
  z-index: 10;
  top: 50%;
  background: url("/slider-navigation-arrow.svg") no-repeat;
  cursor: pointer;

  ${mobileQuery`
    display: none;
  `}
`;

const NavigationNext = styled(NavigationArrow)`
  left: -${navigationSize + navigationPadding}px;
  transform: translateY(-50%) scaleX(-1);
`;

const NavigationPrev = styled(NavigationArrow)`
  right: -${navigationSize + navigationPadding}px;
  transform: translateY(-50%);
`;

const Slider = styled(Swiper)`
  margin: 0;
  cursor: default;
  user-select: none;

  .swiper-slide {
    width: auto;
  }
`;

export const MyOverflowSlider: React.FC<{
  children: React.ReactNodeArray;
}> = (props) => {
  const deviceWidth = useDeviceWidthQuery();

  return (
    <OverflowSlider
      spaceBetween={deviceWidth === DeviceWidth.mobile ? 36 : 72}
      slidesPerView="auto"
      loop
    >
      {props.children}
    </OverflowSlider>
  );
};

const OverflowSlider = styled(MySlider)`
  overflow: visible;
`;
